import { freedomApp } from 'freedom-shared';

import { sentryModel } from '@/shared/model';

import type { BookingSuccessInfo } from '../analytics';
import {
  extractAnalyticsDataLib,
  type extractAnalyticsDataTypes,
} from '../analytics-data-extraction';

const submitSearchForm = (
  params: extractAnalyticsDataTypes.ExtractSearchFormDataParams,
) => {
  const mappedSearchFormParams = {
    ...params,
    city_from: params.city_from.code,
    city_to: params.city_to.code,
  };
  freedomApp.lib.sendAppsFlyerEvent(
    'Aviata_search_button_click_AV',
    mappedSearchFormParams,
    {
      logger: (error: Error) =>
        sentryModel.captureException(
          sentryModel.getReadableError('ERR_SEND_APPSFLYER_EVENT', error),
        ),
    },
  );
};

const bookingSuccess = (info: BookingSuccessInfo) => {
  freedomApp.lib.sendAppsFlyerEvent(
    'Aviata_success_booking_AV',
    {
      order_number: info.orderNumber,
      products: extractAnalyticsDataLib.products(info.products),
      package: extractAnalyticsDataLib.package(info.packageInfo, info.products),
      seat_map: extractAnalyticsDataLib.seatsCodes(info.seatMap),
      ancillary_baggage_count: extractAnalyticsDataLib.baggageCount(
        info.baggage,
      ),
    },
    {
      logger: (error: Error) =>
        sentryModel.captureException(
          sentryModel.getReadableError('ERR_SEND_APPSFLYER_EVENT', error),
        ),
    },
  );
};

export const appsFlyerEventsLib = {
  submitSearchForm,
  bookingSuccess,
};
